"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PEPFILTER_TARGET = exports.PEPFilter = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable max-classes-per-file */

/**
 * Valid values for the filter target
 * @readonly
 * @enum {number}
 */
var PEPFILTER_TARGET = {
  GLOBAL: 0,
  HI: 1,
  ACC: 2
};
exports.PEPFILTER_TARGET = PEPFILTER_TARGET;

var PEPFilterValue = function PEPFilterValue() {
  _classCallCheck(this, PEPFilterValue);
};

var PEPFilter =
/**
 *
 * @param {Object} data
 * @param {string} data.label The label to display for the filter
 * @param {string} data.property The name of the property of products to filter on
 * @param {boolean} data.isInclusive If true the filter shows all products matching any of the filtered values, if false the filter shows only products that match all of the filtered values
 * @param {Array.<Object>} data.values A list of valid values for the filter
 * @param {number|string} data.filterTarget Determines if the filter is global or only targeted at hearing instruments or accessories
 */
function PEPFilter(data) {
  _classCallCheck(this, PEPFilter);

  /**
   * The label to display for the filter
   * @type {string}
   */
  this.label = data.Label || data.label || '';
  /**
   * The name of the property of products to filter on
   * @type {string}
   */

  this.property = data.Property || data.property || '';
  /**
   * If true the filter shows all products matching any of the filtered values, if false the filter shows only products that match all of the filtered values
   * @type {boolean}
   */

  this.isInclusive = !!(data.IsInclusive || data.isInclusive);
  /**
   * A list of valid values for the filter
   * @type {PEPFilterValue[]}
   */

  this.values = function (dataValues) {
    var values = [];

    if (dataValues !== null) {
      dataValues.forEach(function (dataValue) {
        var value = new PEPFilterValue();
        value.label = dataValue.Label || dataValue.label || '';
        value.value = dataValue.Value || dataValue.value || value.label;
        value.isSelected = !!(dataValue.IsSelected || dataValue.isSelected);
        values.push(value);
      });
    }

    return values;
  }(data.Values || data.values);
  /**
   * Determines if the filter is global or only targeted at hearing instruments or accessories
   * @type {PEPFILTER_TARGET}
   */


  this.filterTarget = function (filterTarget) {
    if (filterTarget !== null) {
      switch (data.filterTarget) {
        case PEPFILTER_TARGET.GLOBAL:
          return PEPFILTER_TARGET.GLOBAL;

        case PEPFILTER_TARGET.HI:
          return PEPFILTER_TARGET.HI;

        case PEPFILTER_TARGET.ACC:
          return PEPFILTER_TARGET.ACC;

        case 'hearingInstrumentsList':
          return PEPFILTER_TARGET.HI;

        case 'accessoriesList':
          return PEPFILTER_TARGET.ACC;

        default:
          return PEPFILTER_TARGET.GLOBAL;
      }
    }

    return PEPFILTER_TARGET.GLOBAL;
  }(data.filterTarget);
};

exports.PEPFilter = PEPFilter;